import { useRef } from 'react'
import StringField from './StringField'
import NumberField from './NumberField'
import CustomLookupField from './CustomLookupField'
import EditorField from './EditorField'

export default function EditCollectionForm({
	title,
	description,
	formData = {},
	onFieldChange,
	onSave,
	collectionDetails,
	presetFieldName,
	presetFieldLabel,
	presetFieldValue,
	submitLabel = 'Save',
}) {
	const submitButtonRef = useRef(null)

	const focusSubmit = () => {
		submitButtonRef.current?.focus()
	}

	const renderField = field => {
		const value = formData[field.name] ?? ''

		switch (field.type) {
			case 'string':
				return <StringField key={field.name} field={field} value={value} onChange={onFieldChange} />

			case 'integer':
				return <NumberField key={field.name} field={field} value={value} onChange={onFieldChange} />

			case 'editor':
				return <EditorField key={field.name} field={field} value={value} onChange={onFieldChange} />

			case 'lookup':
				return (
					<CustomLookupField key={field.name} fieldSchema={field} fieldValue={value} onChange={onFieldChange} onItemSelected={focusSubmit} presetFieldName={presetFieldName} presetFieldLabel={presetFieldLabel} presetFieldValue={presetFieldValue} />
				)

			default:
				return null
		}
	}

	return (
		<div className="divide-y divide-gray-200 bg-white shadow sm:rounded-lg">
			<div className="grid max-w-7xl grid-cols-1 gap-x-8 gap-y-10 px-4 py-16 sm:px-6 lg:px-8">
				<div>
					<h2 className="text-base/7 font-semibold text-gray-900">{title}</h2>
					<p className="mt-1 text-sm/6 text-gray-500">{description}</p>
				</div>
				<form className="" onSubmit={(e) => { e.preventDefault(); onSave(); }}>
					<div className="grid"> {collectionDetails.fields.map(field => renderField(field))}</div>
					<div className="mt-8 flex gap-3">
						<button type="submit" ref={submitButtonRef} className={`rounded-md px-3 py-2 text-sm font-semibold text-white shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2 transition-colors duration-200 bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-indigo-600'}`}>
							{submitLabel}
						</button>
					</div>
				</form>
			</div>
		</div>
	)
}
